import { AxiosResponse } from 'axios'

import { CompanyBranch } from 'types/companyBranch'

import { AddAuthSession, _axios } from './axios'

const SIGNIN = `/signin`
const SIGNOUT = `/signout`
const CREATE_USER = `/users`
const UPDATE_USER = (id: string) => `/users/${id}`
const GET_USER_COMPANY_BRANCHES = (id: string) =>
  `/users/${id}/company-branches`

export const authApi = () => {
  const signIn = async (
    email: string,
    pass: string,
  ): Promise<AxiosResponse<any>> => {
    const params = {
      email: email,
      password: pass,
    }
    return await _axios()
      .post(SIGNIN, params)
      .then((res) => {
        AddAuthSession(res.data.accessToken)
        return res.data.id
      })
  }

  const signOut = async (): Promise<void> => {
    await _axios().post(SIGNOUT)
  }

  const createUser = async (data: {
    loginId: string
    name: string
    email: string
    branchId: string
    roleIds: string[]
    status: number
  }): Promise<AxiosResponse<any>> => {
    return await _axios()
      .post(CREATE_USER, data)
      .then((res) => {
        res.data = res.data.user
        return res
      })
  }

  const updateUser = async (
    id: string,
    data: {
      loginId: string
      name: string
      email: string
      roleIds: string[]
      status: number
      branchIds?: string[]
      companyBranchId: string
    },
  ): Promise<AxiosResponse<any>> => {
    const params = {
      loginId: data.loginId,
      name: data.name,
      email: data.email,
      roleIds: data.roleIds,
      status: data.status,
      branchIds: data.branchIds,
      companyBranchId: data.companyBranchId,
    }
    return await _axios()
      .put(UPDATE_USER(id), params)
      .then((res) => {
        res.data = res.data.user
        return res
      })
  }

  /**
   * ユーザーがアクセス可能な支店一覧を取得
   */
  const getUserCompanyBranches = async (
    userId: string,
  ): Promise<AxiosResponse<CompanyBranch[]>> => {
    return await _axios()
      .get(GET_USER_COMPANY_BRANCHES(userId))
      .then((res) => {
        res.data = res.data.companyBranches
        return res
      })
  }

  return {
    signIn,
    signOut,
    createUser,
    updateUser,
    getUserCompanyBranches,
  }
}
